const CourseData = [
  {
    id: 1,
    course_name: "Photography",
    status: "Ongoing",
    type: "Paid",
    category: "Creative",
    image: "/Course-icons/Camera-icon.png",
  },
  {
    id: 2,
    course_name: "Graphic Design",
    status: "Ongoing",
    type: "Paid",
    category: "Creative",
    image: "/Course-icons/Graphic-design-icon.png",
  },
  {
    id: 3,
    course_name: "Android Development",
    status: "Ongoing",
    type: "Paid",
    category: "Technical",
    image: "/Course-icons/Android-icon.png",
  },
  {
    id: 4,
    course_name: "Data Analytics",
    status: "Ongoing",
    type: "Paid",
    category: "Technical",
    image: "/Course-icons/Data-Analytics-icon.png",
  },
  {
    id: "5",
    course_name: "EthicaL Hacking",
    status: "Upcoming",
    type: "Paid",
    category: "Technical",
    image: "/Course-icons/Ethical-Hacking-icon.png",
  },
  {
    id: "6",
    course_name: "Cyber Security",
    status: "Upcoming",
    type: "Paid",
    category: "Technical",
    image: "/Course-icons/Cyber-Security-icon.png",
  },
  {
    id: "7",
    course_name: "Fashion Design",
    status: "Upcoming",
    type: "Paid",
    category: "Creative",
    image: "/Course-icons/Fashion-Design-icon.png",
  },
  {
    id: "8",
    course_name: "Python",
    status: "All",
    type: "Paid",
    category: "Technical",
    image: "/Course-icons/Python-icon.png",
  },
  {
    id: "9",
    course_name: "AI",
    status: "Ongoing",
    type: "Paid",
    category: "Technical",
    image: "/Course-icons/AI-icon.png",
  },
  {
    id: "10",
    course_name: "Novel Writing",
    status: "Ongoing",
    type: "Paid",
    category: "Creative",
    image: "/Course-icons/Novel-Writing-icon.png",
  },
  {
    id: "11",
    course_name: "Music",
    status: "All",
    type: "Free",
    category: "Creative",
    image: "/Course-icons/Music-icon.png",
  },
  {
    id: "12",
    course_name: "Videograpgy",
    status: "Ongoing",
    type: "Paid",
    category: "Creative",
    image: "/Course-icons/Videography-icon.png",
  },
  {
    id: "13",
    course_name: "Chess",
    status: "All",
    type: "Free",
    category: "Creative",
    image: "/Course-icons/Chess-icon.png",
  },
  {
    id: "14",
    course_name: "Content Writing",
    status: "All",
    type: "Paid",
    category: "Creative",
    image: "/Course-icons/Content-Writing-icon.png",
  },
  {
    id: "15",
    course_name: "StandUp Comedy",
    status: "Upcoming",
    type: "Paid",
    category: "Creative",
    image: "/Course-icons/Standup-Comedy-icon.png",
  },
  {
    id: "16",
    course_name: "C++ Programming",
    status: "All",
    type: "Paid",
    category: "Technical",
    image: "/Course-icons/C++_Programming-icon.png",
  },
  {
    id: "17",
    course_name: "Full Stack Development",
    status: "All",
    type: "Paid",
    category: "Technical",
    image: "/Course-icons/Full-Stack-Development-icon.png",
  },
  {
    id: "18",
    course_name: "Web Development",
    status: "All",
    type: "Paid",
    category: "Technical",
    image: "/Course-icons/Web-Development-icon.png",
  },
  {
    id: "19",
    course_name: "UI/UX Design",
    status: "All",
    type: "Paid",
    category: "Technical",
    image: "/Course-icons/UX-Design-icon.png",
  },
  {
    id: "20",
    course_name: "Java Programming",
    status: "Upcoming",
    type: "Paid",
    category: "Technical",
    image: "/Course-icons/Java-Programming-icon.png",
  },
];

export default CourseData;
